import { getContactList, getDyanmicContacts, getStaticContacts } from "../../config/apiConfig";
import {  FETCH_STATIC_CONTACTLIST_BEGIN, FETCH_STATIC_CONTACTLIST_FAILURE, FETCH_STATIC_CONTACTLIST_SUCCESS ,FETCH_DYNAMIC_CONTACTLIST_BEGIN,FETCH_DYNAMIC_CONTACTLIST_SUCCESS,FETCH_DYNAMIC_CONTACTLIST_FAILURE, FETCH_CONTACTLIST_BEGIN, FETCH_CONTACTLIST_SUCCESS, FETCH_CONTACTLIST_FAILURE} from "../constants/contactLists";
import { sbaAxios } from "../utils/sbaAxios";

export const getStaticContactList=()=>{
    return async (dispatch) => {
        dispatch(getStaticContactListBegin());
          try {
              const response = await sbaAxios({
                  url: `${getStaticContacts}`,
                  method: 'get',
              })
            const ContactList = response;
            dispatch(getStaticContactListSuccess(ContactList));
          } catch (error) {
              dispatch(getStaticContactListFailure(error));
          }
      };
} 
const getStaticContactListBegin =()=>({
      type: FETCH_STATIC_CONTACTLIST_BEGIN,
      payload: {},
})
const getStaticContactListSuccess =(ContactList)=>({
    type: FETCH_STATIC_CONTACTLIST_SUCCESS,
    payload: {ContactList},
})
const getStaticContactListFailure =(error)=>({
    type: FETCH_STATIC_CONTACTLIST_FAILURE,
    payload: {error},
})

export const getDyanmicContactList=()=>{
  return async (dispatch) => {
      dispatch(getDyanmicContactListBegin());
        try {
            const response = await sbaAxios({
                url: `${getDyanmicContacts}`,
                method: 'get',
            })
          const ContactList = response;
          dispatch(getDyanmicContactListSuccess(ContactList));
        } catch (error) {
            dispatch(getDyanmicContactListFailure(error));
        }
    };
} 
const getDyanmicContactListBegin =()=>({
    type: FETCH_DYNAMIC_CONTACTLIST_BEGIN,
    payload: {},
})
const getDyanmicContactListSuccess =(ContactList)=>({
  type: FETCH_DYNAMIC_CONTACTLIST_SUCCESS,
  payload: {ContactList},
})
const getDyanmicContactListFailure =(error)=>({
  type: FETCH_DYNAMIC_CONTACTLIST_FAILURE,
  payload: {error},
});


export const getContactsList=(searchTerm)=>{
  return async (dispatch) => {
    dispatch(getContactsListBegin());
      try {
          const response = await sbaAxios({
              url: `${getContactList}${searchTerm}`,
              method: 'get',
          })
        const ContactList = response;
        dispatch(getContactsListSuccess(ContactList));
      } catch (error) {
          dispatch(getContactsListFailure(error));
      }
  };
};
const getContactsListBegin =()=>({
  type: FETCH_CONTACTLIST_BEGIN,
  payload: {},
})
const getContactsListSuccess =(ContactList)=>({
  type: FETCH_CONTACTLIST_SUCCESS,
  payload: {ContactList},
})
const getContactsListFailure =(error)=>({
  type: FETCH_CONTACTLIST_FAILURE,
  payload: {error},
});